import { IPageTabNavLink } from "../interfaces-and-types";

export const businessdetailsLink: IPageTabNavLink[] = [
    {
        name: 'Business Details',
        route: '',
    },
]